// src/constants/budgetConstants.js

import React from 'react';
import { ArrowUpward as IncomeIcon, ArrowDownward as ExpenseIcon } from '@mui/icons-material';

// Transaction types
export const TRANSACTION_TYPES = [
  { value: 'expense', label: 'Expense', icon: <ExpenseIcon color="error" /> },
  { value: 'income', label: 'Income', icon: <IncomeIcon color="success" /> }
];

// Transaction categories
export const TRANSACTION_CATEGORIES = {
  expense: [
    { value: 'labor', label: 'Labor' },
    { value: 'materials', label: 'Materials & Supplies' },
    { value: 'software', label: 'Software & Licenses' },
    { value: 'services', label: 'External Services' },
    { value: 'travel', label: 'Travel & Accommodation' },
    { value: 'meetings', label: 'Meetings & Events' },
    { value: 'taxes', label: 'Taxes & Fees' },
    { value: 'other_expense', label: 'Other Expenses' }
  ],
  income: [
    { value: 'payment', label: 'Client Payment' },
    { value: 'deposit', label: 'Initial Deposit' },
    { value: 'milestone', label: 'Milestone Payment' },
    { value: 'retainer', label: 'Retainer Fee' },
    { value: 'additional', label: 'Additional Services' },
    { value: 'other_income', label: 'Other Income' }
  ]
};

// Default transaction state
export const DEFAULT_TRANSACTION = {
  type: 'expense',
  category: 'labor',
  amount: '',
  description: '',
  date: new Date(),
  invoiceNumber: '',
  isInvoiced: false
};